import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button,MobileStepper } from "@material-ui/core";

import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
	cardIcon: {
		fontSize: theme.spacing(20),
		margin: "0 auto",
		display: "block",
	},
	buttonsContainer: {
		marginTop: theme.spacing(1),
		background: "#ffffff00",
	},
    bottomHint:{
        marginTop: theme.spacing(2),
    }
}));

export default function TicketForm({ticketData}) {
	const classes = useStyles();

	const openTicketPage = () => {
		window.open(`https://anderson.eventpay.ru/api/ticket/${ticketData.uuid}`, "_blank");
	};

	return (
		<>
			<Typography variant="h5" align="center" gutterBottom>
				Информация отправлена на почту {ticketData.email}
			</Typography>
			<Grid container direction="row" justify="center" alignItems="center">
				<Button size="large" variant="outlined" onClick={openTicketPage}>
					Скачать
				</Button>
			</Grid>
			<MobileStepper
				className={classes.buttonsContainer}
				variant="dots"
				steps={3}
				position="static"
				activeStep={2}
				nextButton={
					<Button
						variant="outlined"
						size="small"
						style={{ visibility: "hidden" }}
					>
						К оплате <KeyboardArrowRight />
					</Button>
				}
				backButton={
					<Button
						variant="outlined"
						size="small"
						style={{ visibility: "hidden" }}
					>
						<KeyboardArrowLeft /> Назад
					</Button>
				}
			/>
		</>
	);
}
